import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../../../../assests/css/customer/Carousel.css';
import AppContext from '../../../../../context/AppContext';

const Carousel = () => {
  const navigate = useNavigate();
  const { baseUrlForFiles, baseUrl, setSelectedCategory } = useContext(AppContext);
  const [centerIndex, setCenterIndex] = useState(0);
  const [isRotating, setIsRotating]   = useState(true);
  const [categories, setCategories]   = useState([]);
  const [loading, setLoading]         = useState(true);

  useEffect(() => {
    axios.get(`${baseUrl}/customer/category/getAllCustomerCategories`)
      .then((res) => {
        setCategories(res.data.categories || []);
      })
      .catch((err) => console.error('Error fetching categories:', err))
      .finally(() => setLoading(false));
  }, [baseUrl]);

  useEffect(() => {
    if (isRotating && categories.length > 0) {
      const interval = setInterval(() => {
        setCenterIndex((prev) => (prev + 1) % categories.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [isRotating, categories.length]);

  const getPositionClass = (index) => {
    const diff = (index - centerIndex + categories.length) % categories.length;
    if (diff === 0)                     return 'Homecenter';
    if (diff === 1)                     return 'Homeright-1';
    if (diff === 2)                     return 'Homeright-2';
    if (diff === categories.length - 1) return 'Homeleft-1';
    if (diff === categories.length - 2) return 'Homeleft-2';
    return 'Homehidden';
  };

  // const handleCardClick = (path, isCenter) => {
  //   if (isCenter) navigate(path);
  // };

  if (loading) {
    return (
      <div className="Homecarousel-main-container">
        <p style={{ textAlign: 'center', padding: '40px' }}>Loading...</p>
      </div>
    );
  }

  return (
    <div className="Homecarousel-main-container">
      <div className="Homecarousel-header">
        <h1 className="Homecarousel-main-title">Discover Unlimited Content</h1>
      </div>

      <div className="Homecarousel-wrapper">
        <div className="Homecarousel-container">
          {categories.map((category, index) => {
            const posClass = getPositionClass(index);
            const isCenter = posClass === 'Homecenter';

            return (
              <div
                key={category.id}
                className={`Homecarousel-card ${posClass}`}
                onClick={() => {
  if (!isCenter) {
    setCenterIndex(index);
    return;
  }
  setSelectedCategory(category);
  const name = category.category_name?.toLowerCase().trim();
  if (name === 'men') navigate('/products/men');
  else if (name === 'women') navigate('/products/Women');
  else if (name === 'kids') navigate('/products/kids');
  else if (name === 'accessories') navigate('/products/accessories');
  else navigate(`/${name}`);
}}
                // onClick={() => {
                //   setSelectedCategory(category);
                //   handleCardClick('/kids', isCenter);
                // }}
                onMouseEnter={() => { if (isCenter) setIsRotating(false); }}
                onMouseLeave={() => { if (isCenter) setIsRotating(true); }}
              >
                <div className="Homecarousel-card-image-container">
                  <img
                    src={`${baseUrlForFiles}/${category.category_image}`}
                    alt={category.category_name}
                    className="Homecarousel-card-image Homeactive"
                  />
                </div>

                <div className="Homecarousel-card-overlay">
                  <h2 className="Homecarousel-card-title">{category.category_name}</h2>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Carousel;